import type { ReactNode, SVGProps } from 'react';
import { cssVar } from '../tokens/cssVar';

export type IllustrationSize = 'sm' | 'md' | 'lg';

const px: Record<IllustrationSize, number> = { sm: 96, md: 144, lg: 200 };

export type IllustrationProps = Omit<SVGProps<SVGSVGElement>, 'children'> & {
  size?: IllustrationSize;
  /** Accessible name. Omit for decorative use (the default): the SVG is then aria-hidden. */
  title?: string;
};

/** Primitive color for SVG fills/strokes: `c('berry.400')` → `var(--gg-berry-400)`. */
export const c = (ref: string): string => cssVar(ref);

/** Semantic color: `sc('bg.surface')` → `var(--gg-color-bg-surface)`. */
export const sc = (path: string): string => cssVar(`color.${path}`);

export function IllustrationFrame({
  size = 'md',
  title,
  children,
  ...rest
}: IllustrationProps & { children: ReactNode }) {
  const d = px[size];
  return (
    <svg
      viewBox="0 0 160 160"
      width={d}
      height={d}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}
